module.exports = __webpack_public_path__ + "img/neirongbianji.b7874f17.png";